import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, InputError, Select } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { emptyError } from "../../../utils/commonUtils";
import { FEEDBACK_TARGETS } from "../../../utils/enums";

const FeedbackTarget = observer(({ FeedbackStore }) => {
  const key = "target";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const target = feedback.target;
  const msgs = useMessageGetter("feedback.form.target");

  updateIncluded(key, true);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (!target.value) updateError(key, emptyError(msgs));
  };

  return (
    <div className="rof-feedbackTarget">
      <FormRow
        label={msgs("label")}
        labelFor={`ROF-${key}`}
        labelId={`rof-feedbackTarget`}
      >
        <Select
          id={`ROF-${key}`}
          name={key}
          value={target.value}
          onChange={(e) => handleOnChange(e.target.value)}
          onBlur={handleOnBlur}
          invalid={!!target.error}
          aria-describedby={!!target.error ? `ROF-${key}-error` : null}
          aria-required={true}
        >
          <option value="">{msgs("option.default")}</option>
          {FEEDBACK_TARGETS.map((option) => (
            <option key={option} value={option}>
              {msgs(`option.${option}`)}
            </option>
          ))}
        </Select>
        <InputError
          error={target.error ? target.error : null}
          id={`ROF-${key}-error`}
        />
      </FormRow>
    </div>
  );
});

export default inject("FeedbackStore")(FeedbackTarget);
